import HeaderModule from "./HeaderModule";
import Viewports from "./Viewports";
import $ from 'jquery';

export default class Menu extends HeaderModule {
    constructor() {
        super();

        this.last_trigger = false;

        this.$ELEMENTS = {
            CONTAINER: $('body'),
            HEADER:    $('.site-header'),
            BACK2TOP:  $('.back-to-top'),
            PAGE_FADE: $('.page-fade')
        };

        this.SELECTORS = {
            OPEN:          '.js-menu-open',
            CLOSE:         '.js-menu-close',
            TOGGLE:        '.js-menu-toggle',
            SWITCH_TOGGLE: '.js-menu-switch-toggle',
            HAS_CHILDREN:  '.menu-item-has-children',
            SUB_MENU:      '.sub-menu',
            MOBILE_TITLE:  '.js-mobile-menu-title'
        };

        this.CLASSES = {
            OPEN:    'menu-open',
            LI_OPEN: 'menu-child-open',
            FIX:     'm-fix',
            HEADER:  {
                SCROLLED: 'site-header--scrolled',
                UP:       'site-header--up',
                DOWN:     'site-header--down'
            }
        };

        this.PUSH_STACK = [
            { $li: false, title: $(this.SELECTORS.MOBILE_TITLE).attr('data-default-title') }
        ];

        this.isSubMenuOpen = false;

        this.registerHooks();
    }

    registerHooks() {
        let _this   = this;
        let $window = $(window);
        let $body   = $('body');

        $(this.$ELEMENTS.CONTAINER)
            .on('click', this.SELECTORS.OPEN, function( e ) {
                e.preventDefault();
                _this.open();
                _this.last_trigger = this;
            })
            .on('click', this.SELECTORS.CLOSE, function( e ) {
                e.preventDefault();
                _this.last_trigger = false;
                _this.close();
            })
            .on('click', this.SELECTORS.TOGGLE, function( e ) {
                e.preventDefault();
                _this.toggle(false, this);
            })
            .on('click', this.SELECTORS.SWITCH_TOGGLE, function( e ) {
                e.preventDefault();
                _this.toggle(true, this);
            })
            .on('click', `${this.SELECTORS.SUB_MENU} > li > a`, function( e ) {
                e.stopPropagation();
            })
            .on('click', this.SELECTORS.HAS_CHILDREN, function( e ) {
                e.preventDefault();
                e.stopPropagation();

                if ( $(this).hasClass(_this.CLASSES.OPEN.replace('.', '')) ) {
                    _this.closeLi($(this));
                    return;
                }

                _this.openLi($(this));
            })
            .on('click', this.SELECTORS.MOBILE_TITLE, function( e ) {
                e.stopPropagation();
                e.preventDefault();

                _this.closeCurrentOpenLi();
            });

        this.$ELEMENTS.PAGE_FADE
            .click(function( e ) {
                e.preventDefault();
                if ( _this.isSubMenuOpen ) {
                    _this.closeCurrentOpenLi();
                    return;
                }

                if ( _this.isOpen ) {
                    _this.last_trigger = false;
                    _this.close();
                }
            })
            .on('touchstart', function( e ) {
                e.preventDefault();
                if ( _this.isSubMenuOpen ) {
                    _this.closeCurrentOpenLi();
                    return;
                }

                if ( _this.isOpen ) {
                    _this.last_trigger = false;
                    _this.close();
                }
            });
    }

    appendSubMenuCloseLayers() {

    }

    open() {
        this.$ELEMENTS.CONTAINER.addClass(this.CLASSES.OPEN);
        this.$ELEMENTS.CONTAINER.addClass(this.CLASSES.FIX);
        this.current_state = this.STATES.OPEN;
        // App.Header.closeAllModules('Menu');
        this.$ELEMENTS.HEADER.removeClass(this.CLASSES.HEADER.DOWN);
    }

    close() {
        this.$ELEMENTS.CONTAINER.removeClass(this.CLASSES.OPEN);
        this.$ELEMENTS.CONTAINER.removeClass(this.CLASSES.FIX);
        this.current_state = this.STATES.CLOSE;
    }

    toggle( doSwitch = false, switchTrigger = false ) {
        if ( doSwitch && switchTrigger !== this.last_trigger && this.last_trigger !== false ) {
            this.last_trigger = switchTrigger;
            return;
        }

        if ( this.isOpen ) {
            this.last_trigger = false;
            this.close();
            return;
        }

        this.last_trigger = switchTrigger;
        this.open();
    }

    openLi( $li ) {
        this.closeOpenLis();
        $li.addClass(this.CLASSES.OPEN);
        this.$ELEMENTS.CONTAINER.addClass(this.CLASSES.LI_OPEN);

        this.isSubMenuOpen = true;

        // App.Header.closeAllModules('Menu');
        this.$ELEMENTS.HEADER.removeClass(this.CLASSES.HEADER.DOWN);

        let menuTitle = $li.find('> a').html();

        this.PUSH_STACK.push({ $li: $li, title: menuTitle });
        this.updateMobileTitle(menuTitle);
    }

    closeLi( $li ) {
        $li.removeClass(this.CLASSES.OPEN);
        this.$ELEMENTS.CONTAINER.removeClass(this.CLASSES.LI_OPEN);
        this.isSubMenuOpen = false;
        // App.Header.closeAllModules('Menu');
    }

    closeOpenLis() {
        this.$ELEMENTS.CONTAINER.find(`.sub-menu ${this.SELECTORS.HAS_CHILDREN}`).removeClass(this.CLASSES.OPEN);
        this.$ELEMENTS.CONTAINER.find(`.menu-item.${this.CLASSES.OPEN}`).removeClass(this.CLASSES.OPEN);

        this.$ELEMENTS.CONTAINER.removeClass(this.CLASSES.LI_OPEN);
        this.isSubMenuOpen = false;

        // if ( Viewports.isSM('>') ) {
        // }

        // for ( let i = 0; i < this.PUSH_STACK.length - 1; i++ ) {
        //     this.PUSH_STACK.pop();
        // }
        // this.updateMobileTitle(this.PUSH_STACK[0].title);
    }

    closeCurrentOpenLi() {
        if ( this.PUSH_STACK.length <= 1 ) {
            return;
        }

        let last_pushState = this.PUSH_STACK.pop();

        last_pushState.$li.removeClass(this.CLASSES.OPEN);
        this.$ELEMENTS.CONTAINER.removeClass(this.CLASSES.LI_OPEN);
        this.isSubMenuOpen = false;

        let current_pushState = this.PUSH_STACK[this.PUSH_STACK.length - 1];
        this.updateMobileTitle(current_pushState.title);
    }

    updateMobileTitle( title ) {
        let $mobileTitle = this.$ELEMENTS.CONTAINER.find(this.SELECTORS.MOBILE_TITLE);

        $mobileTitle.html(title);

        if ( this.PUSH_STACK.length <= 1 ) {
            $mobileTitle.removeClass(this.CLASSES.OPEN);
            return;
        }

        $mobileTitle.addClass(this.CLASSES.OPEN);
    }
}
